import type { MeetingTranscriptInfo } from '@/types/meeting-transcripts';
import type { NotificationItem } from '@/types/notification';
import { isMeetingTranscriptReadyForVerification } from '@/utils/meeting-transcription/job';
import { getMatchVerifyPath, getMeetingTranscriptionPath } from '@/utils/meeting-transcription/match-verification';

export const MEETING_TRANSCRIPT_MATCHES_READY_TYPE_KEY = 'meeting_transcript_matches_ready';

export type MeetingTranscriptMatchesReadyData = {
    hospitalId: string;
    meetingTranscriptInfoId: string;
    meetingDate?: string;
};

const asNonEmptyString = (value: unknown): string | null => {
    if (typeof value !== 'string') {
        return null;
    }
    const trimmed = value.trim();
    return trimmed || null;
};

export const parseMeetingTranscriptMatchesReadyData = (data: NotificationItem['data']): MeetingTranscriptMatchesReadyData | null => {
    if (!data || typeof data !== 'object') {
        return null;
    }

    const hospitalId = asNonEmptyString(data.hospitalId);
    const meetingTranscriptInfoId = asNonEmptyString(data.meetingTranscriptInfoId);
    if (!hospitalId || !meetingTranscriptInfoId) {
        return null;
    }

    const meetingDate = asNonEmptyString(data.meetingDate) ?? undefined;
    return { hospitalId, meetingTranscriptInfoId, meetingDate };
};

export const canOpenMeetingTranscriptMatchesReadyVerify = (
    active: MeetingTranscriptInfo | null | undefined,
    meetingTranscriptInfoId: string
): boolean => Boolean(active && active.id === meetingTranscriptInfoId && isMeetingTranscriptReadyForVerification(active.status));

export const resolveMeetingTranscriptMatchesReadyPath = ({
    isAdminUser,
    hospitalId,
    meetingTranscriptInfoId,
    active
}: {
    isAdminUser: boolean;
    hospitalId: string;
    meetingTranscriptInfoId: string;
    active: MeetingTranscriptInfo | null | undefined;
}): string => {
    if (canOpenMeetingTranscriptMatchesReadyVerify(active, meetingTranscriptInfoId)) {
        return getMatchVerifyPath({
            isAdminUser,
            hospitalId,
            sessionId: meetingTranscriptInfoId,
            hospitalContext: isAdminUser
        });
    }

    return getMeetingTranscriptionPath({
        isAdminUser,
        hospitalId,
        hospitalContext: isAdminUser
    });
};
